import { Injectable } from '@angular/core';
import { ColumnApi, GridApi } from 'ag-grid';
import { DataExportHelper } from '../helpers/data-export.helper';
import { IExportTemplate } from '../interfaces/data-export.interface';
import { ExportRowsEnum, ExportResultEnum } from '../enums/data-export.enum';

@Injectable()
export class CsvExportService {
  exportGrid(
    gridApi: GridApi,
    columnApi: ColumnApi,
    rowsMode: ExportRowsEnum,
    fileName: string,
    sheetName: string,
    excluded: string[] = [],
  ): ExportResultEnum {
    if (!gridApi || !columnApi) {
      return ExportResultEnum.GridUnavailable;
    }
    if (
      rowsMode === ExportRowsEnum.Selected &&
      !DataExportHelper.selectedCount(gridApi)
    ) {
      return ExportResultEnum.EmptySelection;
    }
    const rows = DataExportHelper.rowsFromGrid(
      gridApi,
      columnApi,
      rowsMode,
      excluded,
    );
    DataExportHelper.write(rows, fileName, sheetName, 'csv');
    return ExportResultEnum.Success;
  }

  exportTemplate(
    data: any[],
    template: IExportTemplate,
    fileName: string,
    sheetName: string,
  ): ExportResultEnum {
    if (!data || !data.length) {
      return ExportResultEnum.EmptySelection;
    }
    const rows = DataExportHelper.rowsFromTemplate(data, template);
    DataExportHelper.write(rows, fileName, sheetName, 'csv');
    return ExportResultEnum.Success;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/csv-export.service.ts